import React from 'react'

import './CardsList.scss'

export default ({ children }) => {
    return <div className="cards-list">{children}</div>
}
